// utilities/useLeadImportData.js
import { useEffect, useState } from 'react';
import axios from 'axios';

/**
 * Fetches lead‑import counts (grouped by user, period, and source)
 * from the secured analytics endpoint.
 *
 * @param {{ interval?: string, startDate?: string, endDate?: string }} opts
 * @returns {{
 *   users: string[],
 *   features: string[],
 *   periods: string[],
 *   dataByUser: Record<string, Array<Record<string, any>>>,
 *   loading: boolean
 * }}
 */
export default function useLeadImportData({
  interval  = 'daily',
  startDate,
  endDate
}) {
  const [users,    setUsers]    = useState([]);
  const [features, setFeatures] = useState([]);
  const [periods,  setPeriods]  = useState([]);
  const [dataByUser, setDataByUser] = useState({});
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    const fetchCounts = async () => {
      setLoading(true);

      try {
        const sessionID = localStorage.getItem('sessionId');
        const authToken = localStorage.getItem('authToken');
        const params = { interval };
        if (startDate) params.start = startDate;
        if (endDate)   params.end   = endDate;

        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/auth/analytics/lead-import-counts`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
              'x-session-id': sessionID,
            },
            params,
          }
        );

        // Destructure the API response
        const { users, features, periods, dataByUser } = data;

        setUsers(users);
        setFeatures(features);
        setPeriods(periods);
        setDataByUser(dataByUser);
      } catch (error) {
        console.error('Error fetching lead import counts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCounts();
  }, [interval, startDate, endDate]);

  return { users, features, periods, dataByUser, loading };
}
